import { render, staticRenderFns } from "./TestEmailForm.vue?vue&type=template&id=2d0f0bf6&scoped=true&"
import script from "./TestEmailForm.vue?vue&type=script&lang=js&"
export * from "./TestEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./TestEmailForm.vue?vue&type=style&index=0&id=2d0f0bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0f0bf6",
  null
  
)

export default component.exports